var botStructure = {
  name: "",
  type: "BUY",
  market: "btc_usdc",
  dcaOrGrid: "GRID",
  strategy: {
    name: "MAKER-ARB",
    interval: "1m",
    limit: 12,
    threshold: 30,
    arbitragePres: 0.1,
    isTaker: true,
    takerArb: 0.2,
    maxBuy: 1000,
    sellTakerArbitragePres: 0.2,
    sellArbitragePres: 0.1,
    isSellAfterBuy: false,
  },
  orderSize: 50,
  holdAmount: 0,
  quoteAssetBinance: "usdt",
  createdAt: 0,
  takeProfit: 0.0001,
  maxExtraOrders: 0,
  activeExtraOrders: 0,
  stepOfExtraOrder: 1,
  stopLoss: 0.0018,
  isStopLossSet: false,
  multiplier: 1,
  stopAfterDealComplete: false,
  isRunning: false,
  isDeleted: false,
  isPending: false,
  processID: "",
  displayId: "",
};

export const tradingSetupsData = [
  {
    id: "1",
    market: "btc_usdc",
    displayData: {
      totalBots: 2,
      bots: [
        { count: 1, market: "BTC/USDC", type: "BUY" },
        { count: 1, market: "BTC/USDC", type: "SELL" },
      ],
      description:
        "This setup generates higher volume with minimum trading capital and loss.",
      assets: [
        { amount: "$50 worth BTC", exchange: "nash" },
        { amount: "50 USDC", exchange: "nash" },
      ],
      assetsNote: "",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",

      totalVolume: "10,000",
      makerVolume: 80,
      profit: -0.1,
    },
    bots: [
      {
        ...botStructure,
        strategy: { ...botStructure.strategy },
        quoteAssetBinance: "usdc",
        isStopLossSet: true,
      },
      {
        ...botStructure,
        type: "SELL",
        strategy: { ...botStructure.strategy },
        quoteAssetBinance: "usdc",
        isStopLossSet: true,
      },
    ],
  },
  {
    id: "1",
    market: "eth_usdc",
    displayData: {
      totalBots: 2,
      bots: [
        { count: 1, market: "ETH/USDC", type: "BUY" },
        { count: 1, market: "ETH/USDC", type: "SELL" },
      ],
      description:
        "This setup generates higher volume with minimum trading capital.",
      assets: [
        { amount: "$50 worth ETH", exchange: "nash" },
        { amount: "50 USDC", exchange: "nash" },
      ],
      assetsNote: "",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",

      totalVolume: "3,000",
      makerVolume: 80,
      profit: -0.15,
    },
    bots: [
      {
        ...botStructure,
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
        },
        quoteAssetBinance: "usdc",
        takeProfit: 0.001,
        stopLoss: 0.05,
        isStopLossSet: true,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
        },
        quoteAssetBinance: "usdc",
        takeProfit: 0.001,
        stopLoss: 0.05,
        isStopLossSet: true,
      },
    ],
  },
  {
    id: "2",
    market: "fixed",
    displayData: {
      totalBots: 8,
      bots: [
        { count: 1, market: "BTC/USDC", type: "BUY" },
        { count: 1, market: "BTC/USDC", type: "SELL" },
        { count: 1, market: "ETH/USDC", type: "BUY" },
        { count: 1, market: "ETH/USDC", type: "SELL" },
        { count: 1, market: "NEO/USDC", type: "BUY" },
        { count: 1, market: "NEO/USDC", type: "SELL" },
        { count: 1, market: "LINK/USDC", type: "BUY" },
        { count: 1, market: "LINK/USDC", type: "SELL" },
      ],
      description:
        "This setup generates higher taker volume with minimum loss.",
      assets: [
        { amount: "500 USDT", exchange: "binance" },
        { amount: "$500 worth BTC", exchange: "nash" },
        { amount: "$250 worth ETH", exchange: "nash" },
        { amount: "$150 worth NEO", exchange: "nash" },
        { amount: "$100 worth LINK", exchange: "nash" },
      ],
      assetsNote:
        "**Don't need to have exact amounts from each asset. However, based on your available assets daily volume may vary. But make sure to have total assets in binance margin account worths about half of your total assets in nash.",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",
      totalVolume: "10,000",
      makerVolume: 0,
      profit: -0.13,
    },
    bots: [
      {
        ...botStructure,
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 200,
        takeProfit: 0.14,
      },
      {
        ...botStructure,
        type: "SELL",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 200,
        takeProfit: 0.16,
      },
      {
        ...botStructure,
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.14,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.16,
      },
      {
        ...botStructure,
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.15,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.15,
      },
      {
        ...botStructure,
        market: "link_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.15,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "link_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.15,
      },
    ],
  },
  {
    id: "3",
    market: "fixed",
    displayData: {
      totalBots: 2,
      bots: [
        { count: 1, market: "NOIA/USDC", type: "BUY" },
        { count: 1, market: "NOIA/USDC", type: "SELL" },
      ],
      description:
        "This setup generates higher volume with minimum trading capital.",
      assets: [
        { amount: "$20 worth NOIA", exchange: "nash" },
        { amount: "20 USDC", exchange: "nash" },
      ],
      assetsNote: "",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",

      totalVolume: "3,000",
      makerVolume: 60,
      profit: -0.18,
    },
    bots: [
      {
        ...botStructure,
        market: "noia_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "MAKER-TAKER",
        },
        orderSize: 19,
        takeProfit: 0,
        stopLoss: 0.001,
        isStopLossSet: true,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "noia_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "MAKER-TAKER",
        },
        orderSize: 19,
        takeProfit: 0,
        stopLoss: 0.001,
        isStopLossSet: true,
      },
    ],
  },
  {
    id: "4",
    market: "fixed",
    displayData: {
      totalBots: 2,
      bots: [
        { count: 1, market: "NOIA/USDC", type: "BUY" },
        { count: 1, market: "NOIA/USDC", type: "SELL" },
      ],
      description: "This setup generates higher volume with minimum loss.",
      assets: [
        { amount: "$200 worth NOIA", exchange: "nash" },
        { amount: "200 USDC", exchange: "nash" },
      ],
      assetsNote: "",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",

      totalVolume: "2,000",
      makerVolume: 80,
      profit: -0.03,
    },
    bots: [
      {
        ...botStructure,
        market: "noia_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "MAKER-TAKER",
        },
        orderSize: 19,
        takeProfit: 0,
        maxExtraOrders: 10,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1.5,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "noia_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "MAKER-TAKER",
        },
        orderSize: 19,
        takeProfit: 0,
        maxExtraOrders: 10,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1.5,
      },
    ],
  },
  {
    id: "5",
    market: "fixed",
    displayData: {
      totalBots: 8,
      bots: [
        { count: 1, market: "BTC/USDC", type: "BUY" },
        { count: 1, market: "BTC/USDC", type: "SELL" },
        { count: 1, market: "ETH/USDC", type: "BUY" },
        { count: 1, market: "ETH/USDC", type: "SELL" },
        { count: 1, market: "NEO/USDC", type: "BUY" },
        { count: 1, market: "NEO/USDC", type: "SELL" },
        { count: 1, market: "LINK/USDC", type: "BUY" },
        { count: 1, market: "LINK/USDC", type: "SELL" },
      ],
      description: "This setup generates 100% taker volume with profit.",
      assets: [
        { amount: "500 USDT", exchange: "binance" },
        { amount: "$500 worth BTC", exchange: "nash" },
        { amount: "$250 worth ETH", exchange: "nash" },
        { amount: "$150 worth NEO", exchange: "nash" },
        { amount: "$100 worth LINK", exchange: "nash" },
      ],
      assetsNote:
        "**Don't need to have exact amounts from each asset. However, based on your available assets daily volume may vary. But make sure to have total assets in binance margin account worths about half of your total assets in nash.",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote:
        "**Daily Profit/Loss may change based on the market conditions and your trading fee percentage.",
      totalVolume: "3,000",
      makerVolume: 0,
      profit: 0.05,
    },
    bots: [
      {
        ...botStructure,
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 200,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        type: "SELL",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 200,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        market: "link_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
      {
        ...botStructure,
        type: "SELL",
        market: "link_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "BINANCE-ARB",
        },
        orderSize: 100,
        takeProfit: 0.28,
      },
    ],
  },
  {
    id: "6",
    market: "fixed",
    displayData: {
      totalBots: 2,
      bots: [
        { count: 1, market: "BTC/USDC", type: "BUY" },
        { count: 1, market: "BTC/USDC", type: "SELL" },
      ],
      description: "This setup generates profit with low risk.",
      assets: [
        { amount: "$130 worth BTC", exchange: "nash" },
        { amount: "130 USDC", exchange: "nash" },
      ],
      assetsNote: "",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote: "**Daily profit may change based on the market conditions.",

      totalVolume: "500",
      makerVolume: 100,
      profit: 0.1,
    },
    bots: [
      {
        ...botStructure,
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 12,
        takeProfit: 0.2,
        maxExtraOrders: 10,
        activeExtraOrders: 3,
        stepOfExtraOrder: 1,
      },
      {
        ...botStructure,
        type: "SELL",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 12,
        takeProfit: 0.2,
        maxExtraOrders: 10,
        activeExtraOrders: 3,
        stepOfExtraOrder: 1,
      },
    ],
  },
  {
    id: "7",
    market: "fixed",
    displayData: {
      totalBots: 4,
      bots: [
        { count: 1, market: "BTC/USDC", type: "BUY" },
        { count: 1, market: "ETH/USDC", type: "BUY" },
        { count: 1, market: "NEO/USDC", type: "BUY" },
        { count: 1, market: "LINK/USDC", type: "BUY" },
      ],
      description: "This setup generates good volume with low risk.",
      assets: [{ amount: "2000 USDC", exchange: "nash" }],
      assetsNote:
        "If you have less than that, reduce order size. If you have more capital, increase order size. After creating the bot you can edit bot settings in bot details page.",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote: "",

      totalVolume: "10000",
      makerVolume: 100,
      profit: 0.001,
    },
    bots: [
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 50,
        takeProfit: 0.0001,
        maxExtraOrders: 9,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1,
      },
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        market: "eth_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 50,
        takeProfit: 0.0001,
        maxExtraOrders: 9,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1.2,
      },
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 50,
        takeProfit: 0.001,
        maxExtraOrders: 9,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1.5,
      },
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        market: "link_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 50,
        takeProfit: 0.001,
        maxExtraOrders: 9,
        activeExtraOrders: 1,
        stepOfExtraOrder: 1.5,
      },
    ],
  },
  {
    id: "8",
    market: "fixed",
    displayData: {
      totalBots: 1,
      bots: [{ count: 1, market: "NEO/USDC", type: "BUY" }],
      description: "This setup generates good volume with low risk.",
      assets: [{ amount: "2000 USDC", exchange: "nash" }],
      assetsNote:
        "If you have less than that , reduce order size. If you have more capital and need more volume, increase order size. If you have more capital and need to reduce risk , increase extra orders. After creating the bot you can change ordersize / extra orders in bot details page. (click bot id)",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote: "",

      totalVolume: "10000",
      makerVolume: 100,
      profit: 0.05,
    },
    bots: [
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 100,
        takeProfit: 0.1,
        maxExtraOrders: 19,
        activeExtraOrders: 1,
        stepOfExtraOrder: 0.5,
      },
    ],
  },
  {
    id: "9",
    market: "fixed",
    displayData: {
      totalBots: 1,
      bots: [{ count: 1, market: "NEO/USDC", type: "SELL" }],
      description: "This setup generates good volume with low risk.",
      assets: [{ amount: "$2000 worth NEO", exchange: "nash" }],
      assetsNote:
        "If you have less than that , reduce order size. If you have more capital and need more volume, increase order size. If you have more capital and need to reduce risk , increase extra orders. After creating the bot you can change ordersize / extra orders in bot details page. (click bot id)",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote: "",

      totalVolume: "10000",
      makerVolume: 100,
      profit: 0.05,
    },
    bots: [
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        type: "SELL",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "makerBot",
        },
        orderSize: 100,
        takeProfit: 0.1,
        maxExtraOrders: 19,
        activeExtraOrders: 1,
        stepOfExtraOrder: 0.5,
      },
    ],
  },
  {
    id: "10",
    market: "fixed",
    displayData: {
      totalBots: 1,
      bots: [{ count: 1, market: "NEO/USDC", type: "BUY" }],
      description:
        "This setup generates good volume and profit with high risk. If NEO-USDC market pumping bot make profits. But if market dumping bot make losses.",
      assets: [{ amount: "2000 USDC", exchange: "nash" }],
      assetsNote:
        "If you have less than that, reduce 'Max NEO Buy' . If you have more capital, increase 'Max NEO Buy'. After creating the bot you can change settings in bot details page. (click bot id)",
      volumeNote: "**Daily volume may change based on the market conditions.",
      profitNote: "",

      totalVolume: "10000",
      makerVolume: 10,
      profit: "(-0.5)-0.5",
    },
    bots: [
      {
        ...botStructure,
        dcaOrGrid: "DCA",
        market: "neo_usdc",
        strategy: {
          ...botStructure.strategy,
          name: "MARKET-MAKER",
          arbitragePres: 0.05,
          isTaker: true,
          takerArb: 0.13,
          maxBuy: 2000,
          sellTakerArbitragePres: 0.1,
          sellArbitragePres: 0.05,
        },
        orderSize: 100,
        takeProfit: 5,
        maxExtraOrders: 0,
        activeExtraOrders: 0,
        stepOfExtraOrder: 0,
      },
    ],
  },
];
